<template>
  <div class="bg-white px-4 lg:px-12 sticky top-0 z-10 border-b">
    <nav class="text-sm max-w-7xl mx-auto flex whitespace-nowrap overflow-y-auto">
      <RouterLink
        v-for="item in navigation"
        :key="item.name"
        :to="item.route"
        class="px-4 inline-flex h-12 items-center justify-center"
        :class="[
          $route.name === item.route.name
            ? 'text-blue-600 bg-gray-200'
            : 'text-gray-600 hover:bg-gray-200 hover:text-blue-900',
        ]"
      >
        {{ item.name }}
      </RouterLink>
      <ConversationManager
        v-if="$membershipHasPermissionTo('read conversations')"
        :project-id="projectId"
      />
    </nav>
  </div>
</template>

<script>
import ConversationManager from 'Components/ProjectConversation/ConversationManager.vue';

const navigation = [
  {
    name: 'Channels',
    permissions: 'read channels',
    authorized({ can }) {
      return can(this.permissions);
    },
    route: { name: 'accounts.projects.project.channels' },
  },
  {
    name: 'Ads',
    permissions: 'read channels',
    authorized({ can }) {
      return can(this.permissions);
    },
    route: { name: 'accounts.projects.project.ads' },
  },
  {
    name: 'Advertisements',
    permissions: 'read channels',
    authorized({ can }) {
      return can(this.permissions);
    },
    route: { name: 'accounts.projects.project.advertisements' },
  },
  {
    name: 'Assets',
    permissions: 'read assets',
    authorized({ can }) {
      return can(this.permissions);
    },
    route: { name: 'accounts.projects.project.assets' },
  },
  {
    name: 'Pages',
    permissions: 'read pages',
    authorized({ can }) {
      return can(this.permissions);
    },
    route: { name: 'accounts.projects.project.pages' },
  },
  {
    name: 'Contact Requests',
    permissions: 'read contact requests',
    authorized({ can }) {
      return can(this.permissions);
    },
    route: { name: 'accounts.projects.project.contactRequests' },
  },
  {
    name: 'Contact Lists',
    permissions: 'read contact lists',
    authorized({ can }) {
      return can(this.permissions);
    },
    route: { name: 'accounts.projects.project.contactLists' },
  },
  {
    name: 'Pipelines',
    permissions: 'read pipelines',
    authorized({ can }) {
      return can(this.permissions);
    },
    route: { name: 'accounts.projects.project.pipelines' },
  },
  {
    name: 'SMS Campaigns',
    permissions: 'read sms campaigns',
    authorized({ can }) {
      return can(this.permissions);
    },
    route: { name: 'accounts.projects.project.smsCampaigns' },
  },
  {
    name: 'Email Campaigns',
    permissions: 'read email campaigns',
    authorized({ can }) {
      return can(this.permissions);
    },
    route: { name: 'accounts.projects.project.emailCampaigns' },
  },
  {
    name: 'Ad Plans',
    permissions: 'read campaigns',
    authorized({ can }) {
      return can(this.permissions);
    },
    route: { name: 'accounts.projects.project.campaigns' },
  },
  {
    name: 'Management',
    permissions: 'read orders',
    authorized({ can }) {
      return can(this.permissions);
    },
    route: { name: 'accounts.projects.project.management' },
  },
  {
    name: 'Tasks',
    permissions: 'read tasks',
    authorized({ currentAccount, project, can }) {
      const isOwnedByCurrentAccount = currentAccount.id === project?.accountUuid;
      const hasRequiredPermissions = can(this.permissions);
      return isOwnedByCurrentAccount && hasRequiredPermissions;
    },
    route: { name: 'accounts.projects.project.tasks' },
  },
  {
    name: 'Forms',
    permissions: 'read forms',
    authorized({ can }) {
      return can(this.permissions);
    },
    route: { name: 'accounts.projects.project.forms' },
  },
  {
    name: 'Automations',
    permissions: 'read automations',
    authorized({ can }) {
      return can(this.permissions);
    },
    route: { name: 'accounts.projects.project.automations' },
  },
];

export default {
  components: { ConversationManager },
  name: 'Navigation',
  props: {
    accountId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
  },
  computed: {
    project() {
      return this.$store.state.entities.projects.byId[this.projectId] || null;
    },
    navigation() {
      return navigation
        .filter((item) => {
          return (
            this.$isAdminOrSuperAdmin ||
            item.authorized({
              currentAccount: this.$currentAccount,
              project: this.project,
              can: this.$membershipHasPermissionTo,
            })
          );
        })
        .map((item) => ({
          name: item.name,
          route: item.route,
        }));
    },
  },
};
</script>
